<div class="form">
  @if (form) {
    <form (ngSubmit)="save()" matForm [formGroup]="form">
      @if (showDetails()) {
        <div>
          <div class="historyPanel mat-small">
            @if (site.createdDate) {
              <div>
                <strong>created</strong> {{ site.createdDate | date: 'MMM d, yyyy, h:mm:ss a' }}
                @if (site.createdByUserName) {
                  <span><br />by {{ site.createdByUserName }}</span>
                }
              </div>
            }
            @if (site.modifiedDate > site.createdDate) {
              <div>
                <strong>modified</strong> {{ site.modifiedDate | date: 'MMM d, yyyy, h:mm:ss a' }}
                @if (site.modifiedByUserName) {
                  <span><br />by {{ site.modifiedByUserName }}</span>
                }
              </div>
            }
          </div>
          <div class="control-wrapper">
            <mat-form-field appearance="outline" [floatLabel]="'always'">
              <mat-label>Site Name</mat-label>
              <input matInput placeholder="Name" formControlName="name" required>
            </mat-form-field>
          </div>
          <div class="control-wrapper">
            <mat-form-field appearance="outline" [floatLabel]="'always'">
              <mat-label>Description</mat-label>
              <textarea matInput maxlength="500" formControlName="description"></textarea>
            </mat-form-field>
          </div>
          <div class="control-wrapper">
            <mat-form-field appearance="outline" [floatLabel]="'always'">
              <mat-label>BDR/Memo Number and Title:</mat-label>
              <textarea rows="5"
                matInput
                placeholder="Number—title (date exactly as it appears on the BDR) e.g. 'BDR 24-41—Government-wide Tracking of Resources for Cyber Activities and Cyber Workforce (9/16/2024)'"
                formControlName="purpose">
              </textarea>
            </mat-form-field>
          </div>
          <div class="control-wrapper">
            <mat-form-field appearance="outline" [floatLabel]="'always'">
              <mat-label>Frequency</mat-label>
              <mat-select formControlName="frequency">
                @for (f of frequencyOfCollection; track f) {
                  <mat-option [value]="f">
                    {{f}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="control-wrapper">
            <mat-form-field appearance="outline" [floatLabel]="'always'">
              <mat-label>Site Point of Contact</mat-label>
              <input matInput formControlName="maxPointOfContact" [matAutocomplete]="pickerItemPOC">
              <mat-autocomplete #pickerItemPOC [panelWidth]="300" [displayWith]="pickerDisplayFn">
                @for (pi of pocPickerItems | async; track pi) {
                  <mat-option [value]="pi">
                    <span title="{{pi.fullDisplay}}">{{pi.fullDisplay}}</span>
                  </mat-option>
                }
              </mat-autocomplete>
              <div class="loading">
                <span>
                  @if (showLoadingIndicator) {
                    <mat-spinner diameter="25" style="top: -10px;"></mat-spinner>
                  }
                </span>
              </div>
            </mat-form-field>
          </div>
        </div>
      }
      <div class="button-wrapper">
        <button type="button" mat-raised-button color="primary" (click)="save()" (keyup.enter)="save()" [disabled]="!(form.valid && form.dirty)">Save</button>
        @if (!form.dirty) {
          <button type="button" mat-raised-button (click)="cancel()" (keyup.enter)="cancel()">Cancel</button>
        }
        @if (form.dirty) {
          <button type="button" mat-raised-button (click)="reset()" (keyup.enter)="reset()">Reset</button>
        }
      </div>
    </form>
  }
</div>
